<template>
  <!--
    Trabajo a operario
  -->
  <div style="border-left-width:1rem" class="callout callout-danger position-relative overlay-wrapper"
    :style="colorfila">
    <!-- <div class="overlay" v-if="isGuardando == true"><i class="fas fa-3x fa-sync-alt fa-spin"></i>
      <div class="text-bold pt-2">{{$t('general.guardando')}}...</div>
    </div> -->
    <div class="marcado-check">
      <input type="checkbox" v-model="trabajodatos.marcado"
        :true-value="1" :false-value="0" @change="trabajoMarcado"
        title="Marcar trabajo">
    </div>
    <div :title="this.trabajoopciones.eliminable.mensaje" v-if="eliminable == false" class="ribbon ribbon-top-left">
      <span>No eliminable</span>
    </div>
    <div class="ribbon ribbon-top-right ribbon-liquidado">
      <span v-if="liquidado" class="bg-success"
        :title="liquidadoDatos.prefijo + ' Nº' + liquidadoDatos.numero + ' Fecha: ' + liquidadoDatos.fecha">
        &nbsp;&nbsp;{{ liquidadoDatos.prefijo }} Nº {{liquidadoDatos.numero }} {{ liquidadoDatos.fecha }}
      </span>
    </div>
    <div class="row justify-content-between">
      <div></div> <!-- Div vacío para ocupar el espacio a la izquierda -->
      <!--  <span class="badge  nombre-cliente">{{ nombreCliente }}</span>-->

    </div>
    <div class="row" sty>
      <div :style="{ opacity: trabajodatos.trabajo_duplicado == 1 ? 0.5 : 1 }" ref="col1" class="col">
        <div class="input-group">
          <div class="input-group-prepend">
            <button @click="comprobarAxa()" :style="estiloreducido" type="button" class="btn btn-default"
              :disabled="bloqueos.id_baremo != 0" title="Mostrar baremo">
              <i class="fas fa-list"></i>
            </button>
             <button @click="quitarbaremo()" :style="estiloreducido" type="button" class="btn btn-default"
              :disabled="bloqueos.id_baremo != 0" title="No asociar al baremo">
             <i class="fas fa-times"></i>
          </button>
          </div>
          <input type="text" :style="estiloreducido" @input="autosave = true" class="form-control input-xs"
            v-model="trabajodatos.codigo_trabajo" :placeholder="$t('general.codigo')" readonly>
        </div>
        <trabajosbaremos :servicio="servicio" :visible="mostrarBaremo" :trabajodatos="trabajodatos" @update:visible="mostrarBaremo=false"
          :operario="true" />
        <div class="form-group" v-if="mostrar.nombre != 0">
          <textarea style="resize:both;font-size:12px;" @input="autosave=true" class="form-control input-xs"
            v-model="trabajodatos.nombre" :placeholder="$t('general.concepto')" rows="2"
            :readonly="bloqueos.nombre != 0"></textarea>
        </div>
        <!--<span class="badge  nombre-cliente">{{ nombreCliente }}</span>-->

        <!--<span class="badge bg-danger">{{operarioOProveedor}}</span>-->

      </div>
      <div :style="{ opacity: trabajodatos.trabajo_duplicado == 1 ? 0.5 : 1 }" ref="col2" class="col">
        <div class="form-group" v-if="mostrar.descripcion_factura != 0">
          <textarea style="resize:both;font-size:12px;" @input="autosave = true" class="form-control input-xs"
            v-model="trabajodatos.descripcion_factura" :placeholder="$t('general.descripcion')" rows="3"
            :readonly="bloqueos.descripcion_factura != 0"></textarea>
          <!--<span class="input-group-text">{{ trabajodatos.nombre_especialidad}}</span>-->

        </div>
      </div>
      <div :style="{ opacity: trabajodatos.trabajo_duplicado == 1 ? 0.5 : 1 }" ref="col3" class="col" style="max-width: 170px;">
        <div class="input-group " :title="$t('general.fecha') + ' '+ $t('general.subsanado')"
          v-if="mostrar.fecha_finaliza != 0">
          <div class="input-group-prepend">

            <Calendar :style="estiloreducido" @hide="guardardatos()" dateFormat="dd/mm/yy" style="max-width: 120px;"
              v-model="fechaFinalizaDate" :disabled="bloqueos.fecha_finaliza != 0" selectOtherMonths="true"/>
          </div>
          <div class="input-group-append">
            <span :style="estiloreducido" class="input-group-text"><i class="fas fa-calendar-alt"></i></span>
          </div>

        </div>
      </div>
      <div :style="{ opacity: trabajodatos.trabajo_duplicado == 1 ? 0.5 : 1 }" ref="col4" class="col" style="max-width: 170px" v-if="mostrar.descuento_operario != 0">
        <div class="input-group">
          <select :style="estiloreducido" @input="autosave = true" v-model="trabajodatos.desc_incr"
            class="form-control input-xs" v-if="mostrar.desc_incr != 0" :disabled="bloqueos.desc_incr != 0">
            <option value='0'>Descuento</option>
            <option value='1'>Incremento</option>
          </select>
          <div class="input-group-append" @click="mostrarconcepto=!mostrarconcepto">
            <span :style="estiloreducido" class="input-group-text"><i class="fas fa-info"></i></span>
          </div>
        </div>
        <!-- <v-select taggable v-model="trabajodatos.desc"
                    :options="[{ label: 'Descuento', code: 'Descuento' }, { label: 'Incremento', code: 'Incremento' }]" />-->
        <div class="input-group" v-if="mostrar.descuento_aplicado != 0">
          <input :style="estiloreducido" type="number" @input="autosave = true; calculartotal();"
            v-model="trabajodatos.descuento" class="form-control" :readonly="bloqueos.descuento_aplicado != 0">
          <div class="input-group-append">
            <span :style="estiloreducido" class="input-group-text"><i class="fas fa-percentage"></i></span>
          </div>
        </div>
        <div class="input-group" v-if="mostrar.descuento_importe != 0">
          <input :style="estiloreducido" @input="autosave = true; calculartotal();" type="number"
            v-model="trabajodatos.descuento_importe" class="form-control" :readonly="bloqueos.descuento_importe != 0">
          <div class="input-group-append">
            <span :style="estiloreducido" class="input-group-text"><i class="fas fa-euro-sign"></i></span>
          </div>
        </div>
        <div class="input-group" v-if="mostrar.descuento_concepto != 0">
          <textarea @input="autosave=true" v-if="mostrarconcepto" v-model="trabajodatos.descuento_concepto"
            :placeholder="$t('general.conceptodescuento')" class="form-control"
            :readonly="bloqueos.descuento_aplicado != 0"></textarea>
        </div>
      </div>
      <div :style="{ opacity: trabajodatos.trabajo_duplicado == 1 ? 0.5 : 1 }" ref="col5" class="col" style="max-width: 190px">
      </div>
      <div :style="{ opacity: trabajodatos.trabajo_duplicado == 1 ? 0.5 : 1 }" ref="col6" class="col" style="max-width: 200px">
        <div class="input-group " v-if="mostrar.precio_operario != 0 && tipooperario != 'contratado'">
          <div class="input-group-prepend">
            <span :style="estiloreducido" class="input-group-text">{{ $t('general.precio')}} Op.</span>
          </div>
          <input :style="estiloreducido" style="min-width: 80px;" @input="autosave = true; calculartotal();" type="Number"
            v-model="trabajodatos.precio_operario" class="form-control"
            :placeholder="$t('general.precio') + ' ' + $t('general.operario')"
            :readonly="bloqueos.precio_operario != 0">
        </div>
        <div class="input-group "  v-if="mostrar.precio_operario != 0 && tipooperario == 'contratado'" ><!---->
          <div class="input-group-prepend">
            <span :style="estiloreducido" class="input-group-text">Duración</span>
          </div>
          <input :style="estiloreducido" @input="autosave = true; calculartotal();" min="00:00" max="99:59" type="time" step="60"
            v-model="trabajodatos.tiempo_empleado_trabajo" class="form-control" placeholder="Duración"
            :readonly="bloqueos.tiempo_empleado != 0">
        </div>
        <div class="input-group " v-if="mostrar.cantidad != 0">
          <div class="input-group-prepend">
            <span :style="estiloreducido" class="input-group-text">{{$t('general.cantidad')}}</span>
          </div>
          <input :style="estiloreducido" @input="autosave = true; calculartotal();" type="Number"
            v-model="trabajodatos.cantidad" class="form-control" :readonly="bloqueos.cantidad != 0"
            :placeholder="$t('general.cantidad')">
        </div>
        <div class="input-group">
          <div class="input-group-prepend"><span :style="estiloreducido"
              class="input-group-text bg-danger">{{$t('general.total')}}</span></div>
          <input :style="estiloreducido" disabled type="text" class="form-control" :value="preciototal">
          <div class="input-group-append"><span :style="estiloreducido" class="input-group-text"><i
                class="fas fa-euro-sign"></i></span></div>
        </div>
      </div>
      <div :style="{ opacity: trabajodatos.trabajo_duplicado == 1 ? 0.5 : 1 }" ref="col7" class="col" style="max-width: 130px">
        <div class="custom-control custom-switch custom-switch-on-indigo" v-if="mostrar.estado != 0">
          <input @input="autosave=false" @change="guardarsubsanado(false)" v-model="subsanado" type="checkbox"
            class="custom-control-input" :id="trabajodatos.estados"
            :disabled="isCargandoSubsanado || bloqueos.estado != 0 || trabajodatos.trabajo_duplicado == 1">
          <label class="custom-control-label" :for="trabajodatos.estados">{{$t('general.subsanado') }}</label>
          <!-- Spinner o indicador de carga -->
          <!-- <span v-if="isCargandoSubsanado" class="spinner-border spinner-border-sm" role="status"
            aria-hidden="true"></span> -->
        </div>
        <div class="custom-control custom-switch custom-switch-on-success" v-if="mostrar.visto != 0">
          <input @input="autosave = false" v-model="revisado" @change="guardarrevisado(false)" type="checkbox"
            class="custom-control-input" :id="trabajodatos.revisado"
            :disabled="isCargandoRevisado || bloqueos.visto != 0 || trabajodatos.trabajo_duplicado == 1">
          <label class="custom-control-label" :for="trabajodatos.revisado">{{$t('general.revisado')}}</label>
          <!-- <span v-if="isCargandoRevisado" class="spinner-border spinner-border-sm" role="status"
            aria-hidden="true"></span> -->
        </div>
        <!--<div class="custom-control custom-switch custom-switch-on-warning">
          <input @input="autosave = false" v-model="reclamar" type="checkbox" class="custom-control-input"
            :id="trabajodatos.reclamarid" @change="guardarreclamado(reclamar)"
            :disabled="trabajodatos.trabajo_duplicado == 1 || trabajodatos.reclamado_liquidado != 0">
          <label class="custom-control-label" :for="trabajodatos.reclamarid">{{$t('general.reclamar')}}</label>
          <span v-if="isCargandoReclamar" class="spinner-border spinner-border-sm" role="status"
            aria-hidden="true"></span>
        </div>-->
      </div>
      <!--<div class="col" v-if="liquidado" style="display: flex; flex-direction: column; align-items: center;max-width: 120px; height: fit-content; background-color: #367A38; color: white;">
          <span >Liquidado</span>
          <span style="text-align: center;">{{ liquidadoDatos.prefijo }} nº{{ liquidadoDatos.numero }}   {{ liquidadoDatos.fecha }}</span>
      </div>-->
      <div v-if="!liquidado" ref="col8" class="col" style="max-width:105px;min-width:105px;float:right;">
        <div class="btn-group d-flex justify-content-end">
          <button @input="autosave = false" class="btn btn-primary" @click="guardardatos()"><i
              class="fas fa-save"></i></button>
          <button @input="autosave = false" :disabled="eliminable==false || trabajoopciones.color_fila == 'FondoAzul'" class="btn btn-danger" @click="eliminartrabajo()"><i
              class="fas fa-times"></i></button>
        </div>
      </div>
      <div :style="{ opacity: trabajodatos.trabajo_duplicado == 1 ? 0.5 : 1 }" v-if="liquidado" class="col" style="max-width:105px;min-width:105px;float:right;">
      </div>
    </div>
    <div class="row">
      <div ref="col1_5" class="col1_5" :style="{ width: col1_5_ancho + 'px', opacity: trabajodatos.trabajo_duplicado == 1 ? 0.5 : 1 }">
        <span class="badge bg-danger" title="Destinatario del trabajo">{{operarioOProveedor}}</span>
        &nbsp;
        <span class="badge bg-warning" title="Especialidad">{{trabajodatos.nombre_especialidad}}</span>
        &nbsp;
        <span class="badge bg-info" title="Cliente de la visita">{{ nombreCliente }}</span>
        &nbsp;
        <span class="badge bg-secondary" title="Fecha de la visita">{{trabajodatos.fecha_cita}}</span>
        &nbsp;
        <span v-if="trabajodatos.parametros_envio && trabajodatos.parametros_envio!=''" class="badge bg-primary" title="Presupuesto AXA al que pertenece">{{trabajodatos.parametros_envio.id_presuval}}-{{ trabajodatos.parametros_envio.version }}</span>
        &nbsp;
        <span v-if="trabajodatos.trabajo_duplicado == 1" class="badge bg-primary" title="Duplicado">Trabajo duplicado
          automáticamente</span>
      </div>
      <div ref="col1_6" class="" :style="{ width: col1_6_ancho + 'px', opacity: trabajodatos.trabajo_duplicado == 1 ? 0.5 : 1 }">
      </div>
      <div ref="col1_7" class="" :style="{ width: col1_7_ancho + 'px', opacity: trabajodatos.trabajo_duplicado == 1 ? 0.5 : 1 }">
        <span class="custom-switch custom-switch-on-warning">
          <input @input="autosave = false" type="checkbox" v-model="reclamar" class="custom-control-input"
            :id="trabajodatos.reclamarid" @change="guardarreclamado(reclamar)"
            :disabled="trabajodatos.trabajo_duplicado == 1 || trabajodatos.reclamado_liquidado != 0">
          <label class="custom-control-label" :for="trabajodatos.reclamarid">{{ $t('general.reclamar') }}</label>
          <!-- <span v-if="isCargandoReclamar" class="spinner-border spinner-border-sm" role="status"
            aria-hidden="true"></span> -->
        </span>
      </div>
      <div ref="col1_8" class="">
        <button style="font-size:12px" v-if="trabajodatos.trabajo_duplicado == 1" @click="confirmarTrabajo"
          class="btn btn-success" title="Confirmar trabajo duplicado">Confirmar</button>
      </div>
    </div>
    <div v-if="reclamar">
      <trabajosrealizadoreclamado :trabajodatos="trabajodatos" :guardar="guardar"
        @update:trabajodatos="actualizarDatosReclamado" />
    </div>
  </div>
  <!-- Mensaje de Trabajo Duplicado -->
  <!-- <div v-if="trabajodatos.trabajo_duplicado == 1" style="margin-bottom:30px" class="duplicated-work-alert">
    <div class="alert-message">
      Trabajo duplicado automáticamente
    </div>
    <button v-if="trabajodatos.trabajo_duplicado == 1" @click="confirmarTrabajo"
      class="btn btn-success">Confirmar</button>
    <button v-if="trabajodatos.trabajo_duplicado == 1" @click="eliminartrabajo" class="btn btn-danger">Eliminar</button>
  </div>-->
</template>
<style scoped>
/* common */
.marcado-check {
  position: absolute;
  top: 1px;
  left: 1px;
  z-index: 10; /* por encima del ribbon "No eliminable" */
}
.marcado-check input {
  width: 16px;
  height: 16px;
  cursor: pointer;
}
.ribbon {
  width: 100px;
  height: 100px;
  overflow: hidden;
  position: absolute;
}
.miribon{
  box-shadow: 0 0 3px rgba(0,0,0,.3);
  font-size: .8rem;
  line-height: 100%;
  padding: .375rem 0;
  position: relative;
  right: -2px;
  text-align: center;
  text-shadow: 0 -1px 0 rgba(0,0,0,.4);
  text-transform: uppercase;
  top: 10px;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  width: 90px;
  background-color: #28a745 !important;

}
.wrapper.ribbon-lg .ribbon {
  right: 0;
  top: 26px;
  width: 160px;}
.miribon::after, .miribon-wrapper .miribon::before {
  border-left: 3px solid transparent;
  border-right: 3px solid transparent;
  border-top: 3px solid #9e9e9e;
  bottom: -3px;
  content: "";
  position: absolute;}

.ribbon::before,
.ribbon::after {
  position: absolute;
  z-index: -1;
  content: '';
  display: block;
  border: 5px solid #2980b9;
}
.ribbon-wrapper{
  height: 70px;
  overflow: hidden;
  position: absolute;
  right: -2px;
  top: -2px;
  width: 70px;
  z-index: 10;
}
.ribbon span {
  position: absolute;
  display: block;
  width: 175px;
  padding: 5px 0;
  background-color: #3498db;
  box-shadow: 0 5px 10px rgba(0,0,0,.1);
  color: #fff;
  font: 700 10px/1 'Lato', sans-serif;
  text-shadow: 0 1px 1px rgba(0,0,0,.2);
  text-transform: uppercase;
  text-align: center;
  z-index: 20;
}

/* top left*/
.ribbon-top-left {
  top: -1px;
  left: -16px;
}
.stripes {
  background: repeating-linear-gradient(45deg, transparent, transparent 20px, #bd213075 20px, #bd213075 40px);
}
.ribbon-top-left::before,
.ribbon-top-left::after {      

  top: 0;
  right: 0;
}
.ribbon-top-left::after {
  bottom: 0;
  left: 0;
}
.ribbon-top-left span {
  right: -20px;
  top: 25px;
  transform: rotate(-45deg);
}

/* top right*/
.ribbon-top-right {
  top: -10px;
  right: -10px;
}
.ribbon-top-right::before,
.ribbon-top-right::after {
  border-top-color: transparent;
  border-right-color: transparent;  
}
.ribbon-top-right::before {
  top: 0;
  left: 0;
}
.ribbon-top-right::after {
  bottom: 0;
  right: 0;
}
.ribbon-top-right span {
  left: -25px;
  top: 30px;
  transform: rotate(45deg);
}
.ribbon-liquidado {
  top: -5px;
  right: -5px;
  width: 120px;
  height: 120px;
  overflow: hidden;
  text-align: center;
}

/* bottom left*/
.ribbon-bottom-left {
  bottom: -10px;
  left: -10px;
}
.ribbon-bottom-left::before,
.ribbon-bottom-left::after {
  border-bottom-color: transparent;
  border-left-color: transparent;
}
.ribbon-bottom-left::before {
  bottom: 0;
  right: 0;
}
.ribbon-bottom-left::after {
  top: 0;
  left: 0;
}
.ribbon-bottom-left span {
  right: -25px;
  bottom: 30px;
  transform: rotate(225deg);
}

/* bottom right*/
.ribbon-bottom-right {
  bottom: -10px;
  right: -10px;
}
.ribbon-bottom-right::before,
.ribbon-bottom-right::after {
  border-bottom-color: transparent;
  border-right-color: transparent;
}
.ribbon-bottom-right::before {
  bottom: 0;
  left: 0;
}
.ribbon-bottom-right::after {
  top: 0;
  right: 0;
}
.ribbon-bottom-right span {
  left: -25px;
  bottom: 30px;
  transform: rotate(-225deg);
}
.blurred {
    filter: blur(4px);
    pointer-events: none; /* Deshabilita la interacción */
    opacity: 0.6; /* Reduce la opacidad para el efecto de deshabilitado */
}

/* Posiciona el contenedor del precio total en la parte inferior derecha */
.precio-total-container {
    position: absolute;
    bottom: 10px; /* Ajusta la posición inferior según sea necesario */
    right: 10px;  /* Ajusta la posición derecha según sea necesario */
    background-color: #ffffff;
    padding: 10px;
    border-radius: 5px;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.3);
    font-size: 1rem; /* Tamaño de la fuente */
    font-weight: bold; /* Negrita para destacar */
    color: #000000; /* Color del texto */
}

/* Opcional: personaliza aún más el estilo */
.precio-total {
    color: #28a745; /* Color del texto, verde en este caso */
    font-size: 1rem; /* Tamaño de fuente para el precio */
}

.nombre-cliente {
  margin-left: auto;
  margin-right: 50px; /* Opcional, asegura que el margen derecho sea cero */
  margin-bottom: 10px; /* Añade un margen inferior para separar del contenido siguiente */
}
.col1_5 {
  display: inline-block;
  padding: 0px;
  margin-left: 8px;
}
</style>
<script>
import debounce from 'debounce';

import { PwgsApi } from '../../../../services/PwgsApi';
import trabajosrealizadoreclamado from './TrabajoRealizadoReclamado.vue';
import trabajosbaremos from './TrabajoBaremo.vue';
import Calendar from 'primevue/calendar'


export default ({
  props: ['id', 'servicio', 'totales','tipooperario'],
    setup() {
        return;
    },
    components: {
        trabajosbaremos,
        trabajosrealizadoreclamado,
        Calendar
    },
    data() {
        return {
          mostrarBaremo:false,
          showComponent: false,
          trabajodatos: '',
          trabajoopciones: '',
          guardar: false,
          color: 'background-color: white',
          subsanado: false,
          revisado: false,
          facturar: false,
          reclamar: false,
          estado:'',
          eliminable: true,
          preciototal: 0,
          mostrarconcepto: false,
          colorfila: '',
          autosave: false,
          liquidado:false,
          liquidadoDatos:{},
          mostrar: [],
          bloqueos: [],
          guardadoAutomatico: null,  // Almacenará la función de debounce para guardardatos
          isGuardadoAutomaticoPendiente: false, // Variable que indica si hay un autoguardado pendiente
          isCargandoSubsanado: false, // Nuevo estado para controlar la carga del "Subsanado"
          isCargandoRevisado: false, // Nuevo estado para controlar la carga del "Revisado"
          isCargandoReclamar: false, // Nuevo estado para controlar la carga del "Reclamar"
          isGuardando: false, // Nuevo estado para controlar cuando se está guardando,
          estiloreducido:'height:30px;font-size:12px;text-align:right;',
          col1:null,
          col2:null,
          col3:null,
          col4:null,
          col5:null,
          col6:null,
          col7:null,
          col1_5_ancho:0,
          col1_6_ancho:0,
          col1_7_ancho:0,
          resizeObserver:null,
          precios_operario:[]
        };
    },
    methods: {
      trabajoMarcado(){
          this.$emit('trabajomarcado',this.trabajodatos.idtrabajo_servicio, this.trabajodatos.marcado);
      },
      marcarOperario(operario, marcadostodos) {
        console.log('operario', operario, this.totales);
        if(marcadostodos == 1 || marcadostodos == 0){this.trabajodatos.marcado = marcadostodos; return;}
        if(operario.id == this.totales.datos.operarios_idoperario || operario.id == this.totales.datos.proveedores_id_proveedor){
          this.trabajodatos.marcado = operario.marcado;
        }
      },
      async actualizarDatosReclamado(nuevosDatos) {
            const huboCambio = Object.keys(nuevosDatos).some(
                campo => this.trabajodatos[campo] !== nuevosDatos[campo]
            );
            this.trabajodatos = { ...this.trabajodatos, ...nuevosDatos };
            if (!huboCambio) return;
            const api = new PwgsApi();

            try {
                await api.put('trabajos/'+this.trabajodatos.idtrabajo_servicio+'/reclamar', 
                {
                    fecha_reclamacion_trabajo:this.trabajodatos.fecha_reclamacion_trabajo,
                    cantidad_reclamacion_trabajo: this.trabajodatos.cantidad_reclamacion_trabajo,
                    texto_reclamacion_trabajo:this.trabajodatos.texto_reclamacion_trabajo,
                });
            }catch(e){
                this.$toast.add({ severity: 'error', summary: "Error", detail: e, life: 5000 });
            }
        },
      cambiarMarcadoTrue(){
            this.$props.totales.datos.marcado =  true;
        },
        cambiarMarcadoFalse(){
            this.$props.totales.datos.marcado =  false;
        },
      cambiaMarcado(){
        if(this.trabajodatos.marcado){
          this.$props.totales.datos.marcado =  true;
        }else{
          this.$props.totales.datos.marcado =  false;
        }
      },
        toggleComponent() {
          this.showComponent = !this.showComponent;
      },
      autoguardado() {
          if (this.autosave) {
              this.isGuardadoAutomaticoPendiente = true; // Marcar el autoguardado pendiente inmediatamente
              this.guardadoAutomatico();
              this.autosave = false; // Resetear autosave después de guardar
          }
      },
      // Cancelar autoguardado pendiente
      cancelarAutoguardado() {
          if (this.guardadoAutomatico) {
              this.guardadoAutomatico.clear(); // Cancela cualquier autoguardado pendiente
              this.autosave = false;
              this.isGuardadoAutomaticoPendiente = false; //
          }
      },
      cargardatos() {
        this.$props.totales.datos.marcado=false;
        this.trabajodatos = this.$props.totales.datos;
        console.log('trabajodatosdc', this.trabajodatos);
        if(this.trabajodatos.parametros_envio != ''){
          console.log('parametros_envio', this.trabajodatos.parametros_envio);
        }
        this.trabajodatos.marcado = false;
        if (this.trabajodatos.tiempo_empleado_trabajo){
          this.trabajodatos.tiempo_empleado_trabajo = this.trabajodatos.tiempo_empleado_trabajo.split(":")[0] + ":" + this.trabajodatos.tiempo_empleado_trabajo.split(":")[1];
        }
        this.mostrar = this.$props.totales.opciones.mostrar;
        this.bloqueos = this.$props.totales.opciones.bloqueos;
        this.ivaseleccionado = this.trabajodatos.iva_trabajo;
        if(this.$props.totales.opciones.liquidado){
            this.liquidado = true;
            this.liquidadoDatos = this.$props.totales.opciones.liquidado.factura;
            this.trabajodatos.factura_reclamado = this.$props.totales.opciones.liquidado.factura_reclamado;
            this.trabajodatos.factura_reclamado_anulado = this.$props.totales.opciones.liquidado.factura_reclamado_anulado;
        }
        if (this.trabajodatos.estado == "No iniciado") { this.subsanado = false; }
        if (this.trabajodatos.estado == "Subsanado") { this.subsanado = true; }
        if (this.trabajodatos.visto_tramitador_trabajo == 'SI') { this.revisado = true; }
        if (this.trabajodatos.reclamacion_trabajo) { this.reclamar = true; }
        if (this.trabajodatos.facturar_trabajo == 'SI') { this.facturar = true }
        else { this.facturar = false; }
        this.trabajoopciones = this.$props.totales.opciones;
        if (this.trabajoopciones.eliminable.estado == 1) { this.eliminable = true; }
        else { this.eliminable = false; }
        if (this.trabajodatos.reclamacion_trabajo == 'SI') { this.showComponent = true; }
        this.trabajodatos.contadoid = (this.trabajodatos.idtrabajo_servicio + "contado");
        this.trabajodatos.facturarid = (this.trabajodatos.idtrabajo_servicio + "facturar");
        this.trabajodatos.estados = (this.trabajodatos.idtrabajo_servicio + "estado");
        this.trabajodatos.revisado = (this.trabajodatos.idtrabajo_servicio + "revisado");
        this.trabajodatos.reclamarid = (this.trabajodatos.idtrabajo_servicio + "reclamar");
        if (this.trabajodatos.fecha_finaliza === '0000-00-00') {
            this.trabajodatos.fecha_finaliza = null;
        } else {
            var [ano, mes, dia] = this.trabajodatos.fecha_finaliza.split('-');
           if(dia && mes && ano){ this.trabajodatos.fecha_finaliza = dia.toString() + '/' + mes.toString() + '/' + ano.toString();}
            //this.trabajodatos.fecha_finaliza = new Date(this.trabajodatos.fecha_finaliza).toLocaleDateString('es-ES');
        }
        if (this.trabajodatos.fecha_cita === '0000-00-00') {
            this.trabajodatos.fecha_cita = null;
        } else {
            var [anoo, mess, diaa] = this.trabajodatos.fecha_cita.split('-');
            this.trabajodatos.fecha_cita = diaa.toString() + '/' + mess.toString() + '/' + anoo.toString();
            //this.trabajodatos.fecha_cita = new Date(this.trabajodatos.fecha_cita).toLocaleDateString('es-ES');
        }
        this.trabajodatos.fecha = new Date(this.trabajodatos.fecha).toLocaleDateString('es-ES');
        if (this.revisado) { this.color = "background-color:#bdea87"; }
        if (this.trabajoopciones.color_fila == "claro") {
          this.colorfila = "background-color:white";
        }
        if (this.trabajoopciones.color_fila == "FondoVerde") {
          this.colorfila = "background-color:#bdea87";
        }
        if(this.trabajodatos.fecha_finaliza == null){
                this.trabajodatos.fecha_finaliza = this.trabajodatos.fecha_cita;
            }
        if (this.trabajoopciones.color_fila == "FondoAzul") {
          this.colorfila = "background-color: rgba(125, 173, 225, 0.56)";
        }
        this.calculartotal();
      },      
      cambiarFecha(id, fecha) {
          if(id ==this.trabajodatos.idtrabajo_servicio){
              var fechadate = new Date(fecha);
              const [anio, mes, dia] = fechadate.toISOString().split('T')[0].split('-');
              var fehabuena = dia+"/"+mes+"/"+anio;
              this.trabajodatos.fecha_finaliza = fehabuena;
          }
      },
      async guardarsubsanado(id, mostrar=true) {
            if(!id || id ==this.trabajodatos.idtrabajo_servicio){
              if(id != false) {
                    this.subsanado = true;
                }
                this.isCargandoSubsanado = true;
                if (this.isAutoguardadoPendiente()) {
                    this.cancelarAutoguardado();
                    await this.guardardatos(false); // Espera a que el guardado termine
                }
                let subidadatos = { estado: "" };
                if (this.subsanado) { subidadatos.estado = "Subsanado"; }
                else { subidadatos.estado = "No iniciado";  }
                    const api = new PwgsApi();
                    try {
                        await api.put('trabajos/' + this.trabajodatos.idtrabajo_servicio + '/modificar-trabajo', subidadatos);
                        if(mostrar){
                          this.$toast.add({ severity: 'success', summary: "Guardado", detail: "Datos guardados correctamente", life: 2000 });
                        }
                    }
                    catch (error) {
                        this.$toast.add({ severity: 'error', summary: "Error", detail: error, life: 5000 });
                        if (this.subsanado) this.subsanado = false;
                    } finally {
                        // Finalizar la carga
                        this.isCargandoSubsanado = false;
                    }
                this.$parent.$parent.togglerecargar(this.trabajodatos);
            }
        setTimeout(() => {
                 if (this.subsanado == false && this.revisado == true) { 
                   this.guardarrevisado("no", true);
                                  this.$parent.$parent.togglerecargar(this.trabajodatos);


        }
            }, 1000);

        },
      async guardarrevisado(id, mostrar=true, todosup = false, todosdown = false) {
        if(this.bloqueos.visto != 0 || this.trabajodatos.trabajo_duplicado == 1){
              return;
          }
        if(todosup && this.revisado){
          return;
        }
        if(!id || id ==this.trabajodatos.idtrabajo_servicio || id == 'no'){
          if(id != false) {
                this.revisado = true;
              }
          this.isCargandoRevisado = true;

          if (this.isAutoguardadoPendiente()) {
              this.cancelarAutoguardado();
              await this.guardardatos(false); // Espera a que el guardado termine
          }
          if(todosdown) this.revisado = false;
          let subidadatos = { visto: "" };
          if (this.revisado == true) { subidadatos = { visto: "SI" }; }
          else { subidadatos = { visto: "" }; }
          if (id == "no") {subidadatos = { visto: "" }; }
          const api = new PwgsApi();
          try {
            await api.put('trabajos/' + this.trabajodatos.idtrabajo_servicio + '/modificar-trabajo', subidadatos);
            if(this.revisado){
                this.colorfila = "background-color:#bdea87";
            }else{
                this.colorfila = "background-color:white";
            }
            if(mostrar){
              this.$toast.add({ severity: 'success', summary: "Guardado", detail: "Datos guardados correctamente", life: 2000 });
            }
            this.$emit('cambiorevisado', this.trabajodatos.idtrabajo_servicio, this.revisado == true ? 'SI' : '');
          }
          catch (error) {
            this.$toast.add({ severity: 'error', summary: "Error", detail: error, life: 5000 });
            if (this.revisado) this.revisado = false;
          }finally {
              // Finalizar la carga
            this.isCargandoRevisado = false;
              if(id == "no"){
                    this.colorfila = "background-color:white";
                    this.revisado = false;

                }
          }
          this.$parent.$parent.togglerecargar(this.trabajodatos);
        }

      },
      async guardarreclamado() {
        this.isCargandoReclamar = true;

        if (this.isAutoguardadoPendiente()) {
            this.cancelarAutoguardado();
            await this.guardardatos(false); // Espera a que el guardado termine
        }

        let subidadatos = '';

        if (this.reclamar) {
            subidadatos = { reclamar: 'SI' , tipo: 'operario'};
            }
            else {
            subidadatos = { reclamar: '' , tipo: 'operario'};
            }
        const api = new PwgsApi();
        try {
          await api.put('trabajos/' + this.trabajodatos.idtrabajo_servicio + '/reclamar', subidadatos);
          this.$toast.add({ severity: 'success', summary: "Guardado", detail: "Datos guardados correctamente", life: 2000 });
        }
        catch (error) {
          this.$toast.add({ severity: 'error', summary: "Error", detail: error, life: 5000 });
          if (this.reclamar) this.reclamar = false;
        } finally {
            // Finalizar la carga
          this.isCargandoReclamar = false;
            
        }
        this.$parent.$parent.togglerecargar(this.trabajodatos);

      },
      parseFecha(fecha) {
          if (typeof fecha === 'string') {
              // Si es una cadena de texto, asumimos que está en formato DD/MM/YYYY
              let partes = fecha.split('/');
              if (partes.length === 3) {
                  // Crear un nuevo objeto Date utilizando el formato correcto
                  return new Date(partes[2], partes[1] - 1, partes[0]); // Año, Mes, Día
              } else {
                  throw new Error("Formato de fecha no válido");
              }
          } else if (fecha instanceof Date) {
              // Si ya es un objeto Date, simplemente lo devolvemos
              return fecha;
          } else {
              throw new Error("Tipo de dato no soportado para la fecha");
          }
      },
      async comprobarAxa(){
        const api = new PwgsApi();
        var trabajos = await api.get('trabajos/'+ this.id + '/presuval-axa');
        if(!trabajos){
            this.mostrarBaremo=true;
        }else{
            var enviado = false;
            trabajos.forEach(trabajo => {
                if(trabajo.id_trabajo == this.trabajodatos.idtrabajo_servicio && trabajo.Enviado == 'S'){
                    enviado = true;              
                }
            })
            if(enviado){
                alert("Trabajo perteneciente a un presupuesto enviado a AXA.")
            }else{
                this.mostrarBaremo=true;
            }
        }
      },
      async quitarbaremo() {
          const api = new PwgsApi();
          var trabajos = await api.get('trabajos/'+ this.id + '/presuval-axa');
          if(!trabajos){
              let subidadatos = { baremos_trabajos_id_trabajo: 0, quitar_baremo: 1 };
              await api.put('trabajos/' + this.trabajodatos.idtrabajo_servicio + '/modificar-trabajo', subidadatos);
              this.$parent.$parent.togglerecargar(this.trabajodatos, true, false, 'opera');
          }else{
              var enviado = false;
              trabajos.forEach(trabajo => {
                  if(trabajo.id_trabajo == this.trabajodatos.idtrabajo_servicio && trabajo.Enviado == 'S'){
                      enviado = true;              
                  }
              })
              if(enviado){
                  alert("Trabajo perteneciente a un presupuesto enviado a AXA.")
              }else{
                  let subidadatos = { baremos_trabajos_id_trabajo: 0, quitar_baremo: 1 };
                  await api.put('trabajos/' + this.trabajodatos.idtrabajo_servicio + '/modificar-trabajo', subidadatos);
                  this.$parent.$parent.togglerecargar(this.trabajodatos, true, false, 'opera');
              }
          }
      },
      async guardardatos(recargar = true) {
        //PUT  modulos/pwgsapi/index.php/trabajos/:id_trabajo/modificar-trabajo
        if (recargar == true) {
          this.isGuardando = true; // Activar el estado de guardando

        }
        //Cancelamos guardados pendientes si le damos desde el botón también.
        if (this.isAutoguardadoPendiente()) {
            this.cancelarAutoguardado();
        }
        const api = new PwgsApi();
        let auxfechafin;
        if (this.trabajodatos.fecha_finaliza === null || this.trabajodatos.fecha_finaliza === '0000-00-00') {
            auxfechafin = '';
        } else {
            let fecha = this.parseFecha(this.trabajodatos.fecha_finaliza);
            
            // Solo formatear si la fecha es válida
            let auxdiafin = fecha.toLocaleDateString("es-ES", { day: 'numeric' });
            let auxmesfin = fecha.toLocaleDateString("es-ES", { month: 'numeric' });
            
            // Asegurar el formato de dos dígitos para el mes y día
            if (auxmesfin < 10) { auxmesfin = "0" + auxmesfin }
            if (auxdiafin < 10) { auxdiafin = "0" + auxdiafin }

            auxfechafin = auxdiafin + "/" + auxmesfin + "/" + fecha.toLocaleDateString("es-ES", { year: 'numeric' });
        }
        let subidadatos = {          
          tipo_dano: this.trabajodatos.tipo_danyos_asitur_trabajo, nombre: this.trabajodatos.nombre, descripcion_factura: this.trabajodatos.descripcion_factura,
          contado: this.trabajodatos.contado, precio: this.trabajodatos.precio.replace(',', '.'), precio_operario: this.trabajodatos.precio_operario.replace(',', '.'), 
          iva: this.ivaseleccionado, tiempo_empleado: this.trabajodatos.tiempo_empleado_trabajo, descuento: this.trabajodatos.descuento,
          descuento_importe: this.trabajodatos.descuento_importe, cantidad: this.trabajodatos.cantidad, orden: this.trabajodatos.orden,
          destinatario_factura: this.trabajodatos.destinatario_factura, 
          fecha_finaliza: auxfechafin,
          descuento_concepto: this.trabajodatos.descuento_concepto,
          baremos_trabajos_id_trabajo: this.trabajodatos.baremos_trabajos_id_trabajo,
          desc_incr: this.trabajodatos.desc_incr
        }
        try {
          await api.put('trabajos/' + this.trabajodatos.idtrabajo_servicio + '/modificar-trabajo', subidadatos);
          this.guardar = true;
          this.isGuardadoAutomaticoPendiente = false; 
          this.$toast.add({ severity: 'success', summary: this.$t('general.guardado'), detail: this.$t('general.datosguardadoscorrectamente'), life: 2000 });

          if (recargar) {
            console.log('llega');
              this.$parent.$parent.togglerecargar(this.trabajodatos); 
          }else{
            console.log('no llega');
          }
        }
        catch (error) {
          this.isGuardadoAutomaticoPendiente = false; 
          this.$toast.add({ severity: 'error', summary: "Error", detail: error, life: 5000 });
          if (recargar) {
              this.$parent.$parent.togglerecargar(this.trabajodatos);
          }
        } finally {
          if (recargar == true) {
            this.isGuardando = false; // Activar el estado de guardando

          } // Por ahora lo desactivo que ya recarga toda la página al gaurdar
        }
      },
      async eliminartrabajo() {
        const api = new PwgsApi();
        var trabajos = await api.get('trabajos/'+ this.id + '/presuval-axa');
          if(!trabajos){
            if(window.confirm('¿Quiere eliminar el trabajo a operario?')){
              //DELETE  modulos/pwgsapi/index.php/trabajos/:id_trabajo/eliminar-trabajo
              try {
                await api.delete('trabajos/' + this.trabajodatos.idtrabajo_servicio + '/eliminar-trabajo');
                this.$toast.add({ severity: 'success', summary: this.$t('general.guardado'), detail: 'Trabajo eliminado', life: 2000 });
              }
              catch (error) {
                this.$toast.add({ severity: 'error', summary: "Error", detail: this.trabajoopciones.eliminable.mensaje, life: 5000 });
              }
              this.$parent.$parent.togglerecargar(this.trabajodatos, false,true, 'opera');
            }
          }else{
              var enviado = false;
              trabajos.forEach(trabajo => {
                  if(trabajo.id_trabajo == this.trabajodatos.idtrabajo_servicio && trabajo.Enviado == 'S'){
                      enviado = true;              
                  }
              })
              if(enviado){
                  alert("Trabajo perteneciente a un presupuesto enviado a AXA.")
              }else{
                  if(window.confirm('¿Quiere eliminar el trabajo a operario?')){
                    //DELETE  modulos/pwgsapi/index.php/trabajos/:id_trabajo/eliminar-trabajo
                    try {
                      await api.delete('trabajos/' + this.trabajodatos.idtrabajo_servicio + '/eliminar-trabajo');
                      this.$toast.add({ severity: 'success', summary: this.$t('general.guardado'), detail: 'Trabajo eliminado', life: 2000 });
                    }
                    catch (error) {
                      this.$toast.add({ severity: 'error', summary: "Error", detail: this.trabajoopciones.eliminable.mensaje, life: 5000 });
                    }
                    this.$parent.$parent.togglerecargar(this.trabajodatos, false,true, 'opera');
                  }
              }
          }        
      },
      async eliminartrabajosinconf(id) {
          //DELETE  modulos/pwgsapi/index.php/trabajos/:id_trabajo/eliminar-trabajo
          if(id == this.trabajodatos.idtrabajo_servicio){
              const api = new PwgsApi();
              try {
                  await api.delete('trabajos/' + this.trabajodatos.idtrabajo_servicio + '/eliminar-trabajo');
                  this.$toast.add({ severity: 'success', summary: "Eliminado", detail: 'Trabajo eliminado', life: 2000 });
                  this.$parent.$parent.togglerecargar(this.trabajodatos, false,true, 'opera');
              }
              catch (error) {
                  this.$toast.add({ severity: 'error', summary: "Error", detail: this.trabajoopciones.eliminable.mensaje, life: 5000 });
              }
          }
      },
      async confirmarTrabajo() {
          // Lógica para confirmar el trabajo duplicado
          let subidadatos = { trabajo_duplicado: '' }; 
          const api = new PwgsApi();
          try {
              await api.put('trabajos/' + this.trabajodatos.idtrabajo_servicio + '/confirmar-duplicado', subidadatos);
              //this.$toast.add({ severity: 'success', summary: this.$t('general.guardado'), detail: this.$t('general.datosguardadoscorrectamente'), life: 2000 });
              this.$parent.$parent.togglerecargar(this.trabajodatos, false, false, 'opera', true);
          }
          catch (error) {
              this.$toast.add({ severity: 'error', summary: "Error", detail: error, life: 5000 });
              if (this.facturar) this.facturar = false;
          }           
      },

      async subtotalOperario(id_operario) {
        let subtotal = 0;

        // Operario contratado
        if (this.tipooperario === 'contratado') {
          const tiempo = this.trabajodatos.tiempo_empleado_trabajo;
          if (tiempo === '00:00:00' || tiempo === '00:00') {
            return 0;
          }

          let precio_hora;

          // Si ya tenemos el precio en cach�
          if (id_operario in this.precios_operario) {
            console.log('precios_operariodc', this.precios_operario);
            precio_hora = this.precios_operario[id_operario];
          } else {
            const api = new PwgsApi();
            const datos = await api.get('operarios/' + id_operario);
            precio_hora = datos.datos.precio_hora_operario;
            console.log('precios_operariodc2', precio_hora);
            this.precios_operario[id_operario] = precio_hora; // Guardamos en cach�
          }

          const [horas, minutos] = tiempo.split(':').map(Number);
          const horas_trabajo = (horas * 3600 + minutos * 60) / 3600;

          subtotal = horas_trabajo * parseFloat(precio_hora);

          /*console.log('tiempo', tiempo);
          console.log('horas_trabajo', horas_trabajo);
          console.log('precio_hora', precio_hora);
          console.log('subtotal', subtotal);*/

        // Operario aut�nomo
        console.log('subtotaldc', subtotal);
        } else {
          subtotal = this.trabajodatos.precio_operario * this.trabajodatos.cantidad;
        }
        return subtotal;
      },
      async calculartotal() {
        const id_operario = this.trabajodatos.operarios_idoperario.toString();        
        let subtotal = await this.subtotalOperario(id_operario);

        if (subtotal) {
          // Si el descuento es en importe, calcula el porcentaje de descuento
          if (this.trabajodatos.descuento_importe != 0) {
            this.trabajodatos.descuento = (this.trabajodatos.descuento_importe / subtotal) * 100;
            this.trabajodatos.descuento = Math.round(this.trabajodatos.descuento * 100) / 100;
          }
          if (this.trabajodatos.descuento > 999.9999) {
            if (this.trabajodatos.descuento > 1000.0001) {
              this.$toast.add({ severity: 'warn', summary: "Aviso", detail: "Corregido importe de descuento, no puede ser superior a 999.9999%", life: 10000 });
            }
            this.trabajodatos.descuento = 999.9999;
            this.trabajodatos.descuento_importe = subtotal * (999.9999 / 100);
            this.trabajodatos.descuento_importe = Math.round(this.trabajodatos.descuento_importe * 100) / 100;
          }
          // Si el descuento es en porcentaje, calcula el precio total con descuento
          if (this.trabajodatos.descuento != 0) {
            console.log('descuentodc', this.trabajodatos.descuento);
            const descuento = subtotal * (this.trabajodatos.descuento / 100);
            if (this.trabajodatos.desc_incr != 0) {
              this.preciototal = subtotal + descuento;
            } else {
              this.preciototal = subtotal - descuento;
            }
          } else {
            this.preciototal = subtotal;
          }
          this.preciototal = Math.round(this.preciototal * 100) / 100;
        }
      },
      // Método que verifica si hay un autoguardado pendiente
      isAutoguardadoPendiente() {
          return this.isGuardadoAutomaticoPendiente;
      },
      updateWidth() {
          if (this.col1 && this.col2 && this.col3 && this.col4 && this.col5) {
              this.col1_5_ancho = this.col1.offsetWidth + this.col2.offsetWidth + this.col3.offsetWidth + this.col4.offsetWidth + this.col5.offsetWidth;
              this.col1_6_ancho = this.col6.offsetWidth;
              this.col1_7_ancho = this.col7.offsetWidth;
          }
      }
  },
  watch: {
    isGuardadoAutomaticoPendiente(val){
      this.$emit('cambio', val);
    },
    id() {
      this.cargardatos();
    },
    autosave(val) {
      
        if (val === true) {
            this.autoguardado(); // Ejecuta el guardado cuando autosave es true
        }
    },    
  },
  mounted() {
    this.cargardatos();

    this.col1 = this.$refs.col1;
    this.col2 = this.$refs.col2;
    this.col3 = this.$refs.col3;
    this.col4 = this.$refs.col4;
    this.col5 = this.$refs.col5;
    this.col6 = this.$refs.col6;
    this.col7 = this.$refs.col7;
    this.resizeObserver = new ResizeObserver(this.updateWidth);
    if (this.col1) this.resizeObserver.observe(this.col1);
    if (this.col2) this.resizeObserver.observe(this.col2);
    if (this.col3) this.resizeObserver.observe(this.col3);
    if (this.col4) this.resizeObserver.observe(this.col4);
    if (this.col5) this.resizeObserver.observe(this.col5);
    if (this.col6) this.resizeObserver.observe(this.col6);
    if (this.col7) this.resizeObserver.observe(this.col7);
    this.updateWidth(); // Calcular inicialmente
  },
  beforeUnmount() {
      if (this.resizeObserver) {
          this.resizeObserver.disconnect();
      }
  },
  created() {

    // Creación de la función de debounce con un retraso de 5000 ms
    this.guardadoAutomatico = debounce(() => {
            // Crear una función async para manejar el guardado
            const guardar = async () => {
                await this.guardardatos(true); // Guardar los datos
            };
            guardar(); // Ejecutar la función async
        }, 2000); // 5 segundos de espera tras el último cambio antes de guardar
  },
  computed: {
    fechaFinalizaDate: {
      get() {
          if (!this.trabajodatos.fecha_finaliza) return null;
          // Si ya es un objeto Date, lo devolvemos tal cual
          if (this.trabajodatos.fecha_finaliza instanceof Date) {
              return this.trabajodatos.fecha_finaliza;
          }
          // Parseamos "dd/mm/yyyy" a Date
          const [dia, mes, anio] = this.trabajodatos.fecha_finaliza.split('/');
          return new Date(anio, mes - 1, dia);
      },
      set(valor) {
          if (!valor) {
              this.trabajodatos.fecha_finaliza = null;
              return;
          }
          // Formateamos de vuelta a "dd/mm/yyyy" para guardar como antes
          const dia = String(valor.getDate()).padStart(2, '0');
          const mes = String(valor.getMonth() + 1).padStart(2, '0');
          const anio = valor.getFullYear();
          this.trabajodatos.fecha_finaliza = `${dia}/${mes}/${anio}`;
      }
  },
    nombreCliente() {
      if(this.servicio.clientes){
        const clienteId = this.trabajodatos.clientes_idcliente;

        // Verificar si el cliente es el asegurado
        if (this.servicio.clientes.asegurado.idcliente === clienteId) {
            return `Asegurado: ${this.servicio.clientes.asegurado.nombre}`;
        }

        // Verificar si el cliente es un perjudicado
        if (this.servicio.clientes.perjudicados && this.servicio.clientes.perjudicados.length > 0) {
          const perjudicado = this.servicio.clientes.perjudicados.find(c => c.idcliente === clienteId);
          if (perjudicado) {
              return `Perjudicado: ${perjudicado.nombre}`;
          }
        }

        // Si no es asegurado ni perjudicado
        return 'Cliente no encontrado';
      }else{
        return 'Cliente no encontrado';
      }
    },
    operarioOProveedor() {
        if (this.trabajodatos.operarios_idoperario != 0) {
            return "Operario";
        } else if (this.trabajodatos.proveedores_id_proveedor != 0) {
            return "Proveedor";
        } else {
            return '';
        }
    }
  }
})
</script>
